// Fast enough to feel responsive while still coalescing rapid quantity taps.
const ON_CHANGE_DEBOUNCE_TIMER = 150;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Keep the purchase funnel to one Shopify mutation per tap.
// The cart drawer is already rendered in the page and refreshed after every cart mutation,
// so read existing line state from that DOM instead of blocking on /cart.js first.
(() => {
  customElements.whenDefined('product-form').then(() => {
    const ProductForm = customElements.get('product-form');
    if (!ProductForm || ProductForm.prototype.__bhaktiInstantCartState) return;
    ProductForm.prototype.__bhaktiInstantCartState = true;

    ProductForm.prototype.getCartSnapshot = function () {
      const drawer = this.cart?.tagName === 'CART-DRAWER'
        ? this.cart
        : document.querySelector('cart-drawer');

      const items = drawer
        ? Array.from(drawer.querySelectorAll('#CartDrawer .cart-item'))
            .map((row) => {
              const input = row.querySelector('[data-quantity-variant-id]');
              if (!input) return null;

              const variantId = Number(input.dataset.quantityVariantId || 0);
              if (!variantId) return null;

              return {
                id: variantId,
                variant_id: variantId,
                quantity: Math.max(0, Number(input.value || input.getAttribute('value') || 0)),
                key: input.dataset.quantityLineKey || '',
                properties: row.classList.contains('bhakti-cart-auto-gift')
                  ? { _bhakti_free_gift: 'true' }
                  : {},
              };
            })
            .filter(Boolean)
        : [];

      return { items };
    };
  });
})();
